export function prevent_rightclick(event) {
    event.preventDefault();
};